import { ChainId, Token } from '@babydogeswap/sdk'

const { MAINNET, TESTNET } = ChainId

export interface TokenList {
  [symbol: string]: Token
}

export const mainnetTokens: TokenList = {
  eth: new Token(
    MAINNET,
    '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    18,
    'ETH',
    'Binance-Peg Ethereum Token',
    'https://ethereum.org/en/'
  ),
  babydoge: new Token(
    MAINNET,
    '0xc748673057861a797275CD8A068AbB95A902e8de',
    9,
    'BabyDoge',
    'Baby Doge Coin',
    'https://babydogecoin.com/'
  ),
  busd: new Token(
    MAINNET,
    '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/'
  ),
  usdt: new Token(
    MAINNET,
    '0x55d398326f99059fF775485246999027B3197955',
    18,
    'USDT',
    'Tether USD',
    'https://tether.to/'
  ),
  usdc: new Token(
    MAINNET,
    '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    18,
    'USDC',
    'Binance-Peg USD Coin',
    'https://www.centre.io/usdc'
  ),
  btcb: new Token(
    MAINNET,
    '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    18,
    'BTCB',
    'Binance BTC',
    'https://bitcoin.org/'
  ),
  bnb: new Token(
    MAINNET,
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    18,
    'BNB',
    'BNB',
    'https://pancakeswap.finance/'
  ),
  wbnb: new Token(
    MAINNET,
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    18,
    'WBNB',
    'Wrapped BNB',
    'https://www.binance.com/'
  ),
  bdt: new Token(
    MAINNET,
    '0x7BB8E57675D4e65233aE2016D9E1590B2501eb9a',
    18,
    'BDT',
    'Baby Doge Treat',
    'https://babydogeswap.com/'
  ),
  doge: new Token(
    MAINNET,
    '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
    8,
    'Doge',
    'Doge Coin',
    'https://www.binance.com/'
  ),
  cake: new Token(
    MAINNET,
    '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    18,
    'CAKE',
    'PancakeSwap Token',
    'https://pancakeswap.finance/'
  )
}

export const testnetTokens: TokenList = {
  eth: new Token(
    TESTNET,
    '0x4F1aFd93F488876CE4081f88707CC0BB3f8AC171',
    18,
    'ETH',
    'ETH',
    'https://pancakeswap.finance/'
  ),
  babydoge: new Token(
    TESTNET,
    '0x28017936E4e95CcAfe2d3d89C222bF470e58965E',
    9,
    'BabyDoge',
    'Baby Doge Coin',
    'https://babydogecoin.com/'
  ),
  busd: new Token(
    TESTNET,
    '0xdAD13bBe910717BBc9961D02056467d7287fD504',
    18,
    'BUSD',
    'Binance USD',
    'https://www.bakeryswap.org/'
  ),
  usdt: new Token(
    TESTNET,
    '0x8Faa9974386Da6E74Ea735aFaE0966FB62E47724',
    18,
    'USDT',
    'USDT',
    'https://pancakeswap.finance/'
  ),
  usdc: new Token(
    TESTNET,
    '0xCae29929614D46De2E541B63e73a20be7dF5bE48',
    18,
    'USDC',
    'USD Coin',
    'https://pancakeswap.finance/'
  ),
  btcb: new Token(
    TESTNET,
    '0xC8864f8E8534416026D57dF25393164A88eBeea3',
    18,
    'BTCB',
    'BTCB Token',
    'https://pancakeswap.finance/'
  ),
  bnb: new Token(
    TESTNET,
    '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    18,
    'BNB',
    'BNB',
    'https://pancakeswap.finance/'
  ),
  wbnb: new Token(
    TESTNET,
    '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    18,
    'WBNB',
    'Wrapped BNB',
    'https://pancakeswap.finance/'
  ),
  doge: new Token(
    TESTNET,
    '0xC585B86Dc182AF38F56deEB055b673b43A14BBE8',
    8,
    'Doge',
    'Doge Coin',
    'https://www.binance.com/'
  ),
  bdt: new Token(
    TESTNET,
    '0xB3cd9e5Aaa8B5d53d002a023f9cE262d08A35D43',
    18,
    'BDT',
    'Baby Doge Treat',
    'https://babydogeswap.com/'
  ),
  cake: new Token(
    TESTNET,
    '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    18,
    'CAKE',
    'PancakeSwap Token',
    'https://pancakeswap.finance/'
  )
}

export const tokens = (chainId: ChainId): TokenList => {
  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (chainId === ChainId.TESTNET) {
    return Object.keys(mainnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    }, {})
  }

  return mainnetTokens
}
